import React from "react"
import VmoTooltip from "./VmoTooltip"
import { AiFillLock } from 'react-icons/ai'
import PropTypes from 'prop-types'
const VmoLockFeature = ({ content, children, isLocked }) => {
    if (isLocked) {
        return <VmoTooltip content={content} positioin="top center" size="mini" trigger={children} />
    }
    return children
}
export default VmoLockFeature

VmoLockFeature.propTypes = {
    content: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
    isLocked: PropTypes.bool
}
VmoLockFeature.defaultProps = {
    isLocked: false,
    content: 'Locked Feature',
    children: <AiFillLock />
}